var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-06"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1971",
    d: "M25.8935 16.6663C25.8935 19.888 23.2818 22.4997 20.0601 22.4997C16.8385 22.4997 14.2268 19.888 14.2268 16.6663C14.2268 13.4447 16.8385 10.833 20.0601 10.833C23.2818 10.833 25.8935 13.4447 25.8935 16.6663Z",
    stroke: "url(#paint0_linear_57_404)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0001 3.33301C12.6363 3.33301 6.66675 9.36273 6.66675 16.8008C6.66675 21.0539 8.33341 24.3608 11.6667 27.3147C14.0163 29.3967 18.2911 33.8629 20.0001 36.6661C21.7955 33.9186 25.9839 29.3967 28.3334 27.3147C31.6667 24.3608 33.3334 21.0539 33.3334 16.8008C33.3334 9.36273 27.3639 3.33301 20.0001 3.33301Z",
    stroke: "url(#paint1_linear_57_404)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_404",
    x1: 15.1831,
    y1: 14.3621,
    x2: 25.706,
    y2: 13.8996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D25C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_404",
    x1: 8.85254,
    y1: 13.4162,
    x2: 32.9215,
    y2: 12.5699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D25C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8C00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3f24eaa27dc62898bb25835e60780203.svg";
export { ForwardRef as ReactComponent };